<template>
  <div
    ref="centerArea"
    class="center-area"
    :class="[{ 'hide-right': !state.rightPanelVisible }]"
    @click="handleClickCenterArea"
  >
    <!-- {{state}} -->
    <div ref="centerAreaInner" class="center-area-inner">
      <div
        ref="canvasWrapper"
        class="canvas-wrapper"
        :style="canvasWrapperStyle"
      >
        <!--画布-->
        <div
          ref="canvas"
          class="canvas"
          :style="canvasStyle"
          @contextmenu.self="handleCanvasMenu"
        >
          <div v-if="state.gridVisible" class="lines">
            <div
              v-for="(line, index) in state.yList"
              :key="'h' + index + line"
              :style="horizontalLineStyle(line)"
            />
            <div
              v-for="(line, index) in state.xList"
              :key="'v' + index + line"
              :style="verticalLineStyle(line)"
            />
          </div>
          <tumeng-draggable
            v-for="(component, index) in state.currentPageComponentList"
            :key="component.componentId"
            :idx="index"
            :conf="component"
          >
            <component v-if="component.hide == false" :is="component.type" :conf="component" />
          </tumeng-draggable>
        </div>
      </div>

      <!-- 上边尺子-->
      <tumeng-ruler
        direction="horizontal"
        @get-canvas-position="handleGetCanvasPosition"
      />

      <!-- 左边尺子 -->
      <tumeng-ruler
        direction="vertical"
        @get-canvas-position="handleGetCanvasPosition"
      />

      <!-- 右上角的鼠标的x、y坐标 -->
      <div :class="['cursor-position', { upper: !state.rulerVisible }]">
        {{ `X:${state.fakeX}  Y:${state.fakeY}` }}
      </div>

      <!-- 右下角拖拽导航 -->
      <tumeng-navigator />

      <!--最右侧展开/收缩编辑面板的按钮-->
      <div
        class="toggle-right-panel-btn-wrapper"
        @click="handleClickToggleRight"
      >
        <el-icon class="el-icon-arrow-right" />
      </div>
    </div>
  </div>
</template>

<script>
import store from "../../../store/index.js";
import TumengDraggable from "../../tumeng-draggable/src/index.vue";
import TumengText from "../../tumeng-text/src/index.vue";
import TumengNumber from "../../tumeng-number/src/index.vue";
import TumengMultiImg from "../../tumeng-multi-img/src/index.vue";
import TumengPriceTag from "../../tumeng-price-tag/src/index.vue";
import TumengBlock from "../../tumeng-block/src/index.vue";
import TumengTime from "../../tumeng-time/src/index.vue";
import TumengQRCode from "../../tumeng-qr-code/src/index.vue";
import TumengBARCode from "../../tumeng-bar-code/src/index.vue";
import tumengVideo from "../../tumeng-video/src/index.vue";
import tumengAd from "../../tumeng-ad/src/index.vue";
import TumengRuler from "../../tumeng-ruler/src/index.vue";
import TumengNavigator from "../../tumeng-navigator/src/index.vue";
import TumengValuation from "../../tumeng-valuation/src/index.vue";

export default {
  name: "CenterArea",
  components: {
    TumengDraggable,
    TumengText,
    TumengNumber,
    TumengPriceTag,
    TumengMultiImg,
    TumengBlock,
    TumengTime,
    TumengQRCode,
    TumengBARCode,
    tumengVideo,
    tumengAd,
    TumengRuler,
    TumengNavigator,
    TumengValuation,
  },
  data() {
    return {
      state: store.state,
    };
  },
  computed: {
    canvasWrapperStyle() {
      const programData = this.state.programInfo;
      const width = (programData.width + 2) * programData.scale;
      const height = (programData.height + 2) * programData.scale;
      let top = 0;

      const parentHeight = this.state.designAreaHeight;
      if (parentHeight) {
        if (parentHeight >= height + 16) {
          top = (parentHeight - height) / 2;
        }
      }

      return {
        position: "relative",
        marginLeft: "auto",
        marginRight: "auto",
        marginTop: top + "px",
        width: width + "px",
        height: height + "px",
      };
    },
    // 中间画布的样式。里边是draggable列表
    canvasStyle() {
      const programData = this.state.programInfo;
      let top;
      let left;
      if (store.state.canvasLeft && store.state.canvasTop) {
        top = store.state.canvasTop + "px";
        left = store.state.canvasLeft + "px";
      } else {
        if (programData.scale <= 1.0) {
          left = "-" + (programData.width / 2) * (1 - programData.scale) + "px";
          top = "-" + (programData.height / 2) * (1 - programData.scale) + "px";
        } else {
          left = (programData.width / 2) * (programData.scale - 1) + "px";
          top = (programData.height / 2) * (programData.scale - 1) + "px";
        }
      }
      const style = {
        width: programData.width + "px",
        height: programData.height + "px",
        transform: "scale(" + programData.scale + ")",
        cursor: store.state.cursor,
        left,
        top,
      };
      if (programData.pages[store.state.currentPageIdx].bgColor) {
        style.backgroundColor =
          programData.pages[store.state.currentPageIdx].bgColor;
      }
      if (programData.pages[store.state.currentPageIdx].bgImg) {
        style.backgroundImage = `url(${
          programData.pages[store.state.currentPageIdx].bgImg
        })`;
        style.backgroundSize = "contain";
        style.backgroundRepeat = "no-repeat";
        style.backgroundPosition = "center";
      }
      return style;
    },
  },
  created() {
    document.addEventListener(
      "keypress",
      (ev) => {
        if (ev.code === "KeyD") {
          console.log(store.state.programInfo);
          console.log(store.state.activeComponent);
          console.log(store.state.districtList);
        }
      },
      false
    );
    this.init();
    this.keyDown();
  },
  methods: {
    keyDown() {
      // 键盘按下事件
      document.onkeydown = (e) => {
        //事件对象兼容
        let e1 =
          e || event || window.event || arguments.callee.caller.arguments[0];
        //  ctrl：17
        switch (e1.keyCode) {
          case 16:
            // 取消默认事件
            e.preventDefault();
            this.state.isCtrl = true; // 如果ctrl按下就让他按下的标识符变为true
            store.initMultiple();
            break;
        }
      };
      // 键盘抬起事件
      document.onkeyup = (e) => {
        //事件对象兼容
        let e1 =
          e || event || window.event || arguments.callee.caller.arguments[0];
        switch (e1.keyCode) {
          case 16:
            // 取消默认事件
            e.preventDefault();
            this.state.isCtrl = false; // 如果ctrl抬起下就让他按下的标识符变为false
            break;
        }
      };
    },
    handleCanvasMenu(ev) {
      ev = ev || window.event;
      ev.preventDefault();

      store.updateCanvasMenuArgs(true, ev.clientX, ev.clientY);
    },
    init: function () {
      const centerArea = this.$refs.centerAreaInner;
      if (!centerArea) {
        return setTimeout(this.init, 1);
      }

      centerArea.addEventListener(
        "mousemove",
        (ev) => {
          ev = ev || event;
          store.updateCursorPosition({
            cursorX: ev.clientX,
            cursorY: ev.clientY,
          });

          const r = this.$refs.canvas.getBoundingClientRect();
          const fakeX =
            ((ev.clientX - r.x) * store.state.programInfo.width) / r.width;
          const fakeY =
            ((ev.clientY - r.y) * store.state.programInfo.height) / r.height;
          store.updateFakeXY(fakeX, fakeY);
        },
        false
      );

      const elementResizeDetectorMaker = require("element-resize-detector");
      const erd = elementResizeDetectorMaker();

      const rect = centerArea.getBoundingClientRect();
      store.updateDesignSize({ width: rect.width, height: rect.height });
      const scale1 = rect.width / store.state.programInfo.width;
      const scale2 = rect.height / store.state.programInfo.height;
      const suitableScale = scale1 < scale2 ? scale1 - 0.15 : scale2 - 0.15;
      store.updateProgramInfo(
        Object.assign({}, JSON.parse(JSON.stringify(store.state.programInfo)), {
          scale: Number(suitableScale.toFixed(2)),
        })
      );
      erd.listenTo(centerArea, function (element) {
        const scale1 = element.offsetWidth / store.state.programInfo.width;
        const scale2 = element.offsetHeight / store.state.programInfo.height;
        const suitableScale = scale1 < scale2 ? scale1 - 0.15 : scale2 - 0.15;
        store.updateProgramInfo(
          Object.assign(
            {},
            JSON.parse(JSON.stringify(store.state.programInfo)),
            { scale: Number(suitableScale.toFixed(2)) }
          )
        );
        store.updateSuitableScale(Number(suitableScale.toFixed(2)));
        store.updateDesignSize({
          width: element.offsetWidth,
          height: element.offsetHeight,
        });
      });
    },
    // 如果点击的是特定元素，那么取消选择组件
    handleClickCenterArea(ev) {
      ev = ev || window.event;
      if (
        [
          this.$refs.centerArea,
          this.$refs.centerAreaInner,
          this.$refs.canvasWrapper,
          this.$refs.canvas,
        ].indexOf(ev.target) !== -1
      ) {
        store.updateActiveComponentIdx(undefined);
      }
    },
    // 得到canvas区域的坐标
    handleGetCanvasPosition() {
      const canvas = this.$refs.canvas;
      const rect = canvas.getBoundingClientRect();
      store.updateCanvasPosition({
        x: rect.x || rect.left,
        y: rect.y || rect.top,
      });
    },
    // 展开/隐藏右侧
    handleClickToggleRight() {
      store.updateRightPanelVisible(!store.state.rightPanelVisible);
    },
    horizontalLineStyle(line) {
      return {
        width: "100%",
        height: "1px",
        backgroundColor: store.state.gridColor,
        position: "absolute",
        left: "0",
        right: "0",
        top: line + "px",
      };
    },
    verticalLineStyle(line) {
      return {
        width: "1px",
        height: "100%",
        backgroundColor: store.state.gridColor,
        position: "absolute",
        top: "0",
        bottom: "0",
        left: line + "px",
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.center-area {
  box-sizing: border-box;
  position: relative;
  padding: 48px 300px 0 220px;
  height: 100vh;
  background-color: #e7e8f1;
  .center-area-inner {
    width: 100%;
    height: 100%;
    overflow: hidden;
    position: relative;
    .cursor-position {
      &.upper {
        top: 5px;
      }
      position: absolute;
      right: 6px;
      top: 32px;
    }
    .toggle-right-panel-btn-wrapper {
      position: absolute;
      right: 0;
      top: 50%;
      transform: translateY(-50%);
      background-color: #fff;
      border-radius: 4px 0 0 4px;
      padding: 8px 5px 8px 6px;
      cursor: pointer;
      .el-icon-arrow-right {
        transition: 0.3s transform;
        transform: rotate(0deg);
      }
    }
    .canvas {
      position: absolute;
      box-sizing: content-box;
      background-color: #fff;
      box-shadow: 0 0 50px 15px rgba(211, 211, 224, 0.9);
    }
  }
  &.hide-right {
    padding-right: 0;
    .toggle-right-panel-btn-wrapper {
      .el-icon-arrow-right {
        transform: rotate(180deg);
      }
    }
  }
}
</style>
